import * as Sentry from "@sentry/react";
import React from "react";
import ReactDOM from "react-dom/client";

import "./index.css";
import ReactGA from "react-ga4";
import AppContainer from "./AppContainer";
import config from "./config";
import webVitals from "./reportWebVitals";

ReactGA.initialize([
  {
    trackingId: config.googleAnalyticTrackingId,
  },
]);

if (config.env === "prod") {
  Sentry.init({
    dsn: config.sentryDsn,
    integrations: [Sentry.browserTracingIntegration()],
    environment: config.sentryEnvironment,
    release: config.sentryReleaseVersion,
    tracesSampleRate: 0.1,
    ignoreErrors: [
      "Network Error",
      "Request aborted",
      "AxiosError: Request aborted",
    ],
  });
}

const container = document.getElementById("root");
if (!container) throw new Error("Root container missing in index.html");
const root = ReactDOM.createRoot(container);

root.render(
  <React.StrictMode>
    <AppContainer />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
webVitals();
